export default "__VITE_ASSET__89c1bb8e__"